<template>
  <div v-if="url">
    <div v-if="invalidUrl" class="invalid">
      <img src="@/assets/img/ico_qrcode_svg.svg" alt="" class="invalidImg">
      <p>{{locale.message_qrcode_invalid}}</p>
    </div>
    <span v-else class="qr" :class="{invalid: invalidUrl}">
    <vue-qrcode
      :value="url"
      :color="color"
      :width="size"
      :margin="0"
      :class="'qrImg'" />
    </span>
  </div>
</template>

<script>
import VueQrcode from 'vue-qrcode'

const OTA_CHECK_INTERVAL = 10 * 60 * 1000 // 10분마다 ota요청

export default {
  name: 'Qrcode',
  props: [
    'locale',
    'qrcode',
    'isString',
    'setting',
    'publicOta'
  ],
  components: {
    VueQrcode
  },
  computed: {
    invalidUrl () {
      return !this.url || (this.originUrl && this.originUrl === '#')
    },
    color () {
      const hex = this.setting && this.setting.colorHex && this.setting.colorHex.active
      return {
        light: '#ffffff',
        dark: hex ? this.setting.colorHex.color : '#000000'
      }
    },
    size () {
      const qrcodeSize = this.setting.qrcodeSize && this.setting.qrcodeSize.size
      const size = qrcodeSize && parseInt(qrcodeSize)
      return size
        ? parseInt(size)
        : 256
    },
    isPublicMode () {
      return !!this.publicOta
    },
    qrcodeRefreshInterval () {
      const expired = this.setting && this.setting.qrcodeExpired

      if (
        expired &&
        expired.isActive &&
        Number(expired.day) > 0
      ) {
        return Number(expired.day) * 24 * 60 * 60 * 1000
      }

      // 기본 24시간
      return 24 * 60 * 60 * 1000
    }
  },
  mounted () {
    this.$nextTick(() => {
      if (!this.qrcode) return

      this.currentPublicOta = this.publicOta || null
      this.getShortUrl(this.qrcode)

      if (this.isPublicMode) {
        this.startOtaTimers()
      }
    })
  },
  beforeDestroy () {
    this.clearOtaTimers()
  },
  data () {
    return {
      originUrl: null,
      url: null,

      currentPublicOta: null,
      otaCheckTimer: null,
      qrcodeRefreshTimer: null,
      isCheckingOta: false
    }
  },
  methods: {
    async getShortUrl (url) {
      this.originUrl = url

      if (this.isString) {
        this.url = url
        return
      }

      const hasExpired =
        this.setting &&
        this.setting.qrcodeExpired &&
        this.setting.qrcodeExpired.isActive

      const res = await this.$store.dispatch('util/getShortUrl', {
        url,
        ...(hasExpired && {
          days: this.setting.qrcodeExpired.day
        })
      })

      this.url = res || '#'
    },

    startOtaTimers () {
      this.clearOtaTimers()

      // OTA 변경 여부는 10분마다 확인
      this.otaCheckTimer = setInterval(() => {
        this.checkOtaAndRefresh()
      }, OTA_CHECK_INTERVAL)

      this.restartQrcodeRefreshTimer()
    },

    restartQrcodeRefreshTimer () {
      if (this.qrcodeRefreshTimer) {
        clearTimeout(this.qrcodeRefreshTimer)
        this.qrcodeRefreshTimer = null
      }

      if (!this.qrcodeRefreshInterval) return

      this.qrcodeRefreshTimer = setTimeout(() => {
        this.checkOtaAndRefresh(true)
      }, this.qrcodeRefreshInterval)
    },

    clearOtaTimers () {
      if (this.otaCheckTimer) {
        clearInterval(this.otaCheckTimer)
        this.otaCheckTimer = null
      }

      if (this.qrcodeRefreshTimer) {
        clearTimeout(this.qrcodeRefreshTimer)
        this.qrcodeRefreshTimer = null
      }
    },

    async checkOtaAndRefresh (forceRefresh = false) {
      if (!this.isPublicMode || this.isCheckingOta) return

      this.isCheckingOta = true

      try {
        const ota = await this.$store.dispatch(
          'authentication/getOtaKey',
          true
        )

        if (!ota) return

        const hasChanged = ota !== this.currentPublicOta

        if (hasChanged || forceRefresh) {
          this.currentPublicOta = ota

          const updatedUrl = this.replaceOta(
            this.originUrl || this.qrcode,
            ota
          )

          await this.getShortUrl(updatedUrl)

          // 새 단축 URL 생성 시점부터 만료기간 재계산
          this.restartQrcodeRefreshTimer()
        }
      } finally {
        this.isCheckingOta = false
      }
    },

    replaceOta (url, ota) {
      if (!url) return url

      try {
        const parsedUrl = new URL(url, window.location.origin)

        parsedUrl.searchParams.set('k', ota)

        return parsedUrl.toString()
      } catch (error) {
        return url.replace(
          /([?&])k=[^&#]*/,
          `$1k=${encodeURIComponent(ota)}`
        )
      }
    }
  }
}
</script>
